import { useMemo } from 'react';
import {
  LEAVE_FOR_PERSONAL_CIRCUMSTANCES_SUB_TYPES,
  LEAVE_TYPES,
  LEAVE_TYPES_ALIASES,
  MATERNITY_LEAVE_SUB_TYPES,
  PAID_LEAVE_SUB_TYPES,
  SICK_DAY_SUB_TYPES,
} from 'domain/shared/leave';
import { formatLeaveTypeWithSubType } from '../../shared/leaveTypeDisplay';
import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import { EnumDropdown } from 'framework/form';

type LeaveTypeKey = keyof typeof LEAVE_TYPES;

function subTypeLabelMapFor(leaveTypeKey: LeaveTypeKey) {
  switch (leaveTypeKey) {
    case 'PAID_LEAVE':
      return PAID_LEAVE_SUB_TYPES;
    case 'SICK_DAY':
      return SICK_DAY_SUB_TYPES;
    case 'LEAVE_FOR_PERSONAL_CIRCUMSTANCES':
      return LEAVE_FOR_PERSONAL_CIRCUMSTANCES_SUB_TYPES;
    case 'MATERNITY_LEAVE':
      return MATERNITY_LEAVE_SUB_TYPES;
    default:
      return null;
  }
}

export function buildLeaveCompositeTypeFilterOptions(): Record<string, string> {
  const out: Record<string, string> = {};

  (Object.keys(LEAVE_TYPES) as LeaveTypeKey[]).forEach(leaveTypeKey => {
    const typeAlias = LEAVE_TYPES_ALIASES[leaveTypeKey];
    out[typeAlias] = LEAVE_TYPES[leaveTypeKey];

    const subMap = subTypeLabelMapFor(leaveTypeKey);
    if (!subMap) {
      return;
    }

    (Object.keys(subMap) as (keyof typeof subMap)[]).forEach(subKey => {
      out[subKey as string] = formatLeaveTypeWithSubType({
        type: typeAlias,
        subType: subKey as string,
        shortenPaidLeaveLabel: false,
      });
    });
  });

  return out;
}

const LeaveTypeFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  const options = useMemo(() => buildLeaveCompositeTypeFilterOptions(), []);

  return (
    <DropDownFilter {...props}>
      <EnumDropdown {...props} options={options} />
    </DropDownFilter>
  );
};

export default LeaveTypeFilter;
